import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import NewSurvey from './NewSurvey';
import { withAccount } from '../../../components/AccountContext';
import { Loading } from '../../../components/Loading';
import { matchShape } from '../../../components/prop-types';

const NEW_SURVEY_META_QUERY = gql`
  query($accountId: ID!, $resId: ID!) {
    account(id: $accountId) {
      id
      respondent(id: $resId) {
        id
        firstName
        lastName
      }
    }
  }
`;

const NewSurveyContainer = (props) => {
  const { match, currentAccount } = props;
  const { respondentId } = match.params;
  return (
    <Query
      query={NEW_SURVEY_META_QUERY}
      variables={{
        id: match.params.templateId,
        accountId: currentAccount,
        resId: respondentId,
      }}
    >
      {({ loading, error, data }) => {
        if (loading) return <Loading />;
        if (error) return `Error! ${error.message}`;

        return (
          <NewSurvey
            {...props}
            currentAccount={currentAccount}
            data={data}
          />
        );
      }}
    </Query>
  );
};

NewSurveyContainer.propTypes = {
  match: matchShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withAccount(NewSurveyContainer);
